import React from 'react';
import {Checkbox as AntdCheckbox} from 'antd';
import {coerceToBoolean} from '../metadata/coercer';

export function Checkbox({value, onChange,...props}) {
  value = coerceToBoolean(value);
  return <AntdCheckbox checked={value} onChange={(e)=>onChange(e.target.checked)} {...props}/>
}